import { toast } from "sonner";

/**
 * saveBanner — thin wrapper around sonner that renders a top-center
 * sliding pill for save actions (green on success, red on error). Used
 * across Fleet, Rates modal, Blackouts modal, Locations, and the public
 * booking flow so admins always get the same feedback cadence.
 *
 * v3.8.6.
 */
const DURATION = 2200;

const baseClass =
  "!rounded-full !py-3 !px-6 !font-medium !shadow-lg !border";

export function saveSuccess(
  message = "Changes saved successfully",
  { onDismiss } = {},
) {
  const id = toast.success(message, {
    duration:       DURATION,
    position:       "top-center",
    className:      `${baseClass} !bg-emerald-600 !text-white !border-emerald-500 save-banner-slide`,
    unstyled:       false,
    dismissible:    true,
    onAutoClose:    () => onDismiss && onDismiss(),
    onDismiss:      () => onDismiss && onDismiss(),
  });
  return id;
}

export function saveError(message) {
  return toast.error(message || "Something went wrong", {
    duration:    4200,
    position:    "top-center",
    className:   `${baseClass} !bg-rose-600 !text-white !border-rose-500 save-banner-slide`,
    dismissible: true,
  });
}
